"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowService = exports.WindowService = void 0;
var window_service_1 = require("./window-service");
Object.defineProperty(exports, "WindowService", { enumerable: true, get: function () { return window_service_1.WindowService; } });
Object.defineProperty(exports, "windowService", { enumerable: true, get: function () { return window_service_1.windowService; } });
